/**
 * Shared dropdown options for forms
 * Used across Create and Edit forms to ensure consistency
 */

export const ENTITY_CATEGORY_OPTIONS = [
    { value: "", label: "Select entity category" },
    { value: "client", label: "Client" },
    { value: "vendor", label: "Vendor" },
];

export const ENTITY_LOB_TYPE_OPTIONS = [
    // { value: "", label: "Select entity LOB type" },
    { value: "travel", label: "Travel" },
    { value: "company", label: "Company" },
    { value: "auto", label: "Auto" },
    { value: "gadget", label: "Gadget" },
];

export const LOB_NATIONALITY_OPTIONS = [
    // { value: "", label: "Select selected LOB type nationality" },
    { value: "Domestic", label: "Domestic" },
    { value: "international", label: "International" },
];

export const DEPARTMENT_FUNCTION_OPTIONS = [
    { value: "", label: "Select department function" },
    { value: "finance", label: "Finance" },
    { value: "operations", label: "Operations" },
    { value: "hr", label: "Human Resources" },
    { value: "it", label: "Information Technology" },
    { value: "sales", label: "Sales" },
    { value: "marketing", label: "Marketing" },
];

export const ENTITY_TYPE_OPTIONS = [
    { value: "", label: "Select entity type" },
    { value: "proprietorship", label: "Proprietorship" },
    { value: "partnership", label: "Partnership" },
    { value: "llp", label: "Limited Liability Partnership (LLP)" },
    { value: "private_limited", label: "Private Limited Company" },
    { value: "public_limited", label: "Public Limited Company" },
    { value: "trust", label: "Trust" },
    { value: "society", label: "Society" },
];

export const ACCOUNT_TYPE_OPTIONS = [
    { value: "", label: "Select account type" },
    { value: "savings", label: "Savings" },
    { value: "current", label: "Current" },
];

export const YES_NO_OPTIONS = [
    { value: "", label: "Select option" },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
];
